import React, { Component } from 'react';
import { connect }          from 'react-redux';

import './index.scss';

//components
import BenefitsMap from '../../../category_page/benefits-map';
import Filters from '../../../category_page/filters';

//assets
import desktop_exit from 'assets/icons/login-x-icon.svg';
import {getMediaPath} from "../../../../app/functions";


class MapViewPopup extends Component {

    constructor(props) {
        super(props);
        this.state = {
            animation_class: '',
            popup_id: this.props.popup_id
        }
        this.animateOut = this.animateOut.bind(this);
        this.animateIn  = this.animateIn.bind(this);
    }

    static getDerivedStateFromProps(props, state) {
        if(props.popup_id !== state.popup_id) {
            return {animation_class: 'active'}
        }
        return {};
    }

    /* add class for animation after it is inserted into the DOM */
    componentDidMount() {
        this.animateIn();
    }

    animateIn() {
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                this.setState({animation_class: 'active'});
            })
        })
    }

    /* first remove the active class for exit animation then call the callback */
    animateOut(callback) {
        this.setState({animation_class: ''});
        setTimeout(() => {
            if(callback) {
                callback(this.state.selected_id);
            }
            this.props.handleClose();
        }, 200);
    }

    render() {
        const device = this.props.deviceState;
        const Text   = this.props.text;

        return (
            <div className = { "backdrop " + this.state.animation_class } onClick = { () => this.animateOut() }>
                <div className = {"popup_wrapper map-view-popup " + this.state.animation_class} onClick = { (e) => e.stopPropagation() }>
                    <div className = "popup_content">
                        <div className="exit">
                            <button className = "x_close_icon"
                                    onClick = { () => this.animateOut() }
                                    aria-label="סגור">
                                <img src={ getMediaPath(desktop_exit) } alt="" />
                            </button>
                        </div>
                        <div className='map'>
                            <Filters/>
                            <BenefitsMap/>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

//connect to redux store
const mapStateToProps = store => {
    return {
        deviceState: store.state.deviceState,
        text: store.config.Translations
    }
}

export default connect(mapStateToProps, null, null, { pure: false })(MapViewPopup);